import { DateTime } from 'luxon';
import { TableShiftPlanningListItem } from 'ogp/services/shift-service.types';
import { TableShiftPlanningColumnDefinition } from '../shift-planning-table.types';
import {
  getMultiDayShiftGroupSizes,
  sortTableShiftPlanningItems,
} from '../helpers/sort-table-shift-planning-items';
import { getMultiDayShiftDayMetadata } from '../helpers/get-multi-day-shift-day-metadata';

export const getTableShiftPlanningData = (
  data: TableShiftPlanningListItem[]
): TableShiftPlanningColumnDefinition[] => {
  const sortedItems = sortTableShiftPlanningItems(data);
  const multiDayShiftGroupSizes = getMultiDayShiftGroupSizes(sortedItems);
  const multiDayShiftDayIndexes: Record<string, number> = {};

  const result: TableShiftPlanningColumnDefinition[] = sortedItems.map((item) => {
    const dateTime = {
      fromDateTime: DateTime.fromISO(item.dateTime.fromDateTime),
      toDateTime: DateTime.fromISO(item.dateTime.toDateTime),
    };

    let multiDayShiftDayIndex: number | undefined;
    let multiDayShiftDayCount: number | undefined;

    if (item.multiDayShiftId != null) {
      const dayMetadata = getMultiDayShiftDayMetadata(
        item.multiDayShiftId,
        multiDayShiftDayIndexes,
        multiDayShiftGroupSizes
      );
      multiDayShiftDayIndex = dayMetadata.multiDayShiftDayIndex;
      multiDayShiftDayCount = dayMetadata.multiDayShiftDayCount;
    }

    return {
      id: item.id,
      multiDayShiftId: item.multiDayShiftId,
      multiDayShiftDayIndex,
      multiDayShiftDayCount,
      jobName: item.jobName,
      departmentName: item.departmentName,
      companyName: item.companyName,
      jobTypeName: item.jobTypeName,
      location: item.location,
      dateTime,
      state: item.state,
      action: item.id,
    };
  });
  return result;
};
